import React, { useState } from "react";
import { Grid, Button } from "@material-ui/core";
import { TextField } from "@material-ui/core";
import axios from "axios";
import * as sweetalert from "sweetalert";
import packageJson from "../../../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
const RegistrationForm = () => {
  const [open, setOpen] = React.useState(false);
  const [formValues, setFormValues] = useState({
    link: {
      value: "",
      error: false,
      errorMessage: "You must enter a whats link",
    },
    link_name: {
      value: "",
      error: false,
      errorMessage: "You must enter an  name",
    },
    icon: {
      value: "",
      error: false,
      errorMessage: "You must enter an whats icon",
    },
  });
  const handleChange = (e) => {
    e.persist();
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };
  const handlefile = (e) => {
    e.persist();
    setFormValues({ ...formValues, [e.target.name]: e.target.files[0] });
  };

  const handleSubmit = (e) => {
    const bodyFormData = new FormData();
    bodyFormData.append("link", formValues.link);
    bodyFormData.append("link_name", formValues.link_name);
    bodyFormData.append("icon", formValues.icon);

    e.preventDefault();
    axios
      .post(`${BaseUrl}/api/contact`, bodyFormData, {
        withCredentials: true,
      })
      .then((res) => {
     
        if (res.data.status === true) {
        

          setOpen(true);
          sweetalert("تمت عملية الاضافة بنجاح", {
            className: "alert-div",
            button: {
              text: "تم",
            },
          });
          window.location.reload();
        } else {
          sweetalert("خطأ في البيانات", {
            className: "alert-div",
            button: {
              text: "تم",
            },
          });
          setFormValues({ ...formValues, error_list: res.data.error });
        }
      });
  };

  return (
    <div>
      <form
        method="post"
        enctype="multipart/form-data"
        noValidate
        onSubmit={handleSubmit}
        open={open}
      >
        <div className="form-group">
          <Grid container maxWidth="sm" spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                placeholder="الرجاء ادخال رابط المنصة"
                type="text"
                className="form-control"
                variant="outlined"
                label="رابط الأيقونة"
                name="link"
                value={formValues.link.value}
                onChange={handleChange}
                error={formValues.link.error}
                helperText={
                  formValues.link.error &&
                  formValues.link.errorMessage
                }
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                placeholder="الرجاء ادخال صورة الايقونة"
                className="form-control"
                variant="outlined"
                label="صورة الأيقونة"
                name="icon"
                type="file"
                value={formValues.icon.value}
                onChange={handlefile}
                error={formValues.icon.error}
                helperText={
                  formValues.icon.error &&
                  formValues.icon.errorMessage
                }
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                type="text"
                className="form-control"
                placeholder="الرجاء ادخال اسم المنصة"
                label="اسم المنصة"
                name="link_name"
                variant="outlined"
                required
                value={formValues.link_name.value}
                onChange={handleChange}
                error={formValues.link_name.error}
                helperText={
                  formValues.link_name.error && formValues.link_name.errorMessage
                }
              />
            </Grid>
          </Grid>
        </div>

        <Grid item md={6} xs={12} spacing={2} class="div-btn-submit">
          <Button
            type="submit"
            variant="contained"
            className="btn-submit"
            color="secondary"
          >
            حفظ
          </Button>
        </Grid>
      </form>
    </div>
  );
};

export default RegistrationForm;
